import { useEffect, useState } from "react";
import "./MatchCard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateCasinoSlice } from "../../../../AsianExchangeSrc/redux/slices/casinoSlice";
import Bach from "../../../public/wireless.svg";
import CasinoBalance from "../../../../CommonComponents/CasinoBalance";
import { newSky } from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";

const MatchCard = ({ gameData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const [showCasinoModal, setShowCasinoModal] = useState(false);
  const [selectedGame, setSelectedGame] = useState({ gameId: "", name: "" });
    const SkyDesign = useSelector(newSky());

  const { matches: cricketMatches } = useSelector(
    (state) => state.matches.cricket
  );
  const { matches: soccerMatches } = useSelector(
    (state) => state.matches.soccer
  );
  const { matches: tennisMatches } = useSelector(
    (state) => state.matches.tennis
  );

  const filterInplayMatches = (matches) => {
    return matches?.data?.filter((e) =>
      e?.matchOdds?.some((odds) => odds?.inplay)
    );
  };

  const filteredCricketMatches = filterInplayMatches(cricketMatches);
  const filteredSoccerMatches = filterInplayMatches(soccerMatches);
  const filteredTennisMatches = filterInplayMatches(tennisMatches);

  const [addData, setAddData] = useState([
    {
      id: "1",
      name: "Sports",
      category: "Sports",
      gameId: "/cricket",
      images: [{ type: "banner", url: "casino/banner-sport1.png" }],
      live: [],
      isAddData: true,
    },
    {
      id: "2",
      name: "Sports Book",
      category: "Sports Book",
      gameId: "#",
      images: [{ type: "banner", url: "casino/sportbook.png" }],
      isAddData: true,
    },
    {
      id: "3",
      name: "Fun Games",
      category: "Live Casino",
      gameId: "/casino-games/live-casino",
      images: [{ type: "banner", url: "casino/fungames-730_280.gif" }],
      blog: "Live Casino Blog",
      isAddData: true,
    },
    {
      id: "4",
      name: "Evo",
      category: "Evo",
      gameId: "/casino-games?gameId=evolution",
      images: [{ type: "banner", url: "casino/evolution.png" }],
      isAddData: true,
    },
    {
      id: "5",
      name: "Ezugi",
      category: "Ezugi",
      gameId: "/casino-games?gameId=ezugi",
      images: [{ type: "banner", url: "casino/banner_ezugi-half.png" }],
      isAddData: true,
    },
    {
      id: "6",
      name: "Spribe",
      category: "Spribe",
      gameId: "/casino-games?gameId=spribe",
      images: [{ type: "banner", url: "casino/aviator-730-280.gif" }],
      isAddData: true,
    },
       {
      id: "7",
      name: "Mines",
      category: "Mines",
      gameId: "/casino-games?gameId=spribe",
      images: [{ type: "banner", url: "casino/evoplay-730-280.gif" }],
      isAddData: true,
    },
    {
      id: "8",
      name: "AE Sexy",
      category: "AE Sexy",
      gameId: "/casino-games?gameId=sagaming",
      images: [{ type: "banner", url: "casino/aesexy.png" }],
      isAddData: true,
    },
   
  ]);

  const handleCasinoOpen = (eventId, casinoType) => {
    if (["Kabaddi", "Soccer", "Tennis", "Sports"].includes(casinoType)) {
      navigate(`${eventId}`);
    } else {
      navigate(`${eventId}`);
    }
  };

  const handleIntCasinoOpen = (gameId, gameName) => {
    if (!isLoggedIn) {
      console.log("You are not logged in");
      navigate("/login");
    } else {
      setSelectedGame({ gameId, name: gameName });
      setShowCasinoModal(true);
    }
  };

  const apiGames =
    gameData?.flatMap((item) => {
      const games = item?.provider?.gameList || [];
      return games.map((game) => ({ ...game, isApiGame: true }));
    }) || [];

  const combinedGames = [...addData, ...apiGames];

  useEffect(() => {
    dispatch(updateCasinoSlice({ casinoList: combinedGames }));
  }, [combinedGames, dispatch]);


  return (
    <div className="card-container card-container2">
      {combinedGames?.map((game, index) => {
        const { gameId, category, name, images, isAddData, isApiGame } = game;

        const imageSrc =
          images?.find((img) => img.type === "banner")?.url ||
          images?.find((img) => img.type === "logo-square")?.url ||
          images?.find((img) => img.type === "logo-round")?.url ||
          "";

        const eventId = gameId || `default-${index}`;
        const casinoType = category || "Casino";

        return (
          <div
            className="card"
            key={index}
            onClick={() =>
              isApiGame
                ? handleIntCasinoOpen(eventId, name)
                : handleCasinoOpen(eventId, casinoType)
            }
          >
            {imageSrc ? (
              <img src={imageSrc} alt={name} className="card-image" />
            ) : (
              <div className="card-image-placeholder">{name}</div>
            )}

            {game?.isPlay ? (
              <></>
            ) : (
              <div
                className={`card-content ${
                  SkyDesign === "true" ? "bg-black !border-none" : ""
                }`}
              >
                <h3 className="card-title">{name}</h3>
                <button
                  className={`${
                    SkyDesign === "true"
                      ? "p-2 border-none text-[13px] block md:hidden"
                      : "card-button"
                  }`}
                >
                  Play Now
                </button>
              </div>
            )}

            {game.live && game.live.length >= 0 && (
              <div className="live_Match">
                <div className="badge">
                  <strong className="bach-box">
                    <img src={Bach} alt="Live Indicator" />
                  </strong>
                  <span className="badge-text">Live</span>
                </div>

                <div className="live_Match_lists_wrapper">
                  <div className="live_Match_lists">
                    <p>Cricket</p>
                    <span>{filteredCricketMatches?.length || 0}</span>
                  </div>

                  <div className="live_Match_lists">
                    <p>Soccer</p>
                    <span>{filteredSoccerMatches?.length || 0}</span>
                  </div>

                  <div className="live_Match_lists">
                    <p>Tennis</p>
                    <span>{filteredTennisMatches?.length || 0}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}

      {showCasinoModal && (
        <CasinoBalance
          onClose={() => setShowCasinoModal(false)}
          title={"Casino"}
          gameId={selectedGame.gameId}
          gameName={selectedGame.name}
          isLoggedIn={isLoggedIn}
        />
      )}
    </div>
  );
};

export default MatchCard;
